// extracted by mini-css-extract-plugin
export default {"login-unavailable-hero":"src-assets-style-scss-___login-unavailable__login-unavailable-hero___0NhrB"};